module.exports = __webpack_public_path__ + "img/clock.2ad283fe.svg";